<template>
  <div class="code_show" style="overflow-y: scroll; height: 300px">
    <div>详情页面使用说明:</div>
    <div>在父级页面添加一下监听方法：</div>
    <pre>
            &lt;script&gt;
              window.addEventListener("message", (res) => { 
                try { 
                  let data =  JSON.parse(res.data) 
                  let url = data.url; // 返回详情页只要的URL地址
                  let typeName = data.typeName;
                  //打开新的页面(只是一个试例)
                  window.location.href=`跳转地址?type=${typeName}`
              } catch (e) { } });
            &lt;/script&gt;
          </pre
    >
    <pre>
            详情页面里：
              1.在页面中添加iframe标签；
                  &lt;frame class="iframe" border="0"&gt;&lt;/iframe&gt;
              2.javascript代码
              &lt;script&gt;
                {{ code }}
              &lt;/script&gt;
          </pre
    >
  </div>
</template>

<script>
export default {
  props: {
    path: [String],
    iframeSrc: [String],
  },
  computed: {
    code() {
      let path = this.path;
      return `let type = getQuery('type') //获取url参数
              let iframeSrc = \`${window.location.origin}${path}?type=\$\{type\}\`
              let queryIframe = document.querySelector('iframe')
              queryIframe.setAttribute('src',iframeSrc) `;
    },
  },
};
</script>

<style lang="scss" scoped></style>
